
export class NotasColegioModel {

    idNota: number;
    codAlun: number;
    codInst: number;
    codTurm: number;
    codDisc: number;
    tipProv: number;
    seqNota: number;
    notaDis: number;
    notaSin: number;
    notaRec: number;
    notaAvlb: number;
    notaBonu: number;
    /* faltas:number;
    
    mp1: number;
    rec1: number;
    mb1: number;

    mp2: number;
    rec2: number;
    mb2: number;

    mp3: number;
    rec3: number;
    mb3: number;

    mp4: number;
    rec4: number;
    mb4: number; */
}

function NotasColegioModel_tsickle_Closure_declarations() {
/** @type {?} */
NotasColegioModel.prototype.idNota;
/** @type {?} */
NotasColegioModel.prototype.codAlun;
/** @type {?} */
NotasColegioModel.prototype.codInst;
/** @type {?} */
NotasColegioModel.prototype.codTurm;
/** @type {?} */
NotasColegioModel.prototype.codDisc;
/** @type {?} */
NotasColegioModel.prototype.tipProv;
/** @type {?} */
NotasColegioModel.prototype.seqNota;
/** @type {?} */
NotasColegioModel.prototype.notaDis;
/** @type {?} */
NotasColegioModel.prototype.notaSin;
/** @type {?} */
NotasColegioModel.prototype.notaRec;
/** @type {?} */
NotasColegioModel.prototype.notaAvlb;
/** @type {?} */
NotasColegioModel.prototype.notaBonu;
}
